import { twJoin } from "tailwind-merge";

export const PermissionListLayout = (props: Omit<React.ComponentPropsWithRef<"div">, "className">): React.ReactNode => {
  return <div {...props} className="flex flex-wrap gap-x-8 gap-y-4 py-space-sm @sm:gap-x-12" />;
};

export const PermissionWrapper = ({
  children,
  layout,
}: {
  children: React.ReactNode;
  layout: "horizontal" | "vertical";
}): React.ReactNode => {
  return (
    <section className={twJoin("w-full shrink-0", layout === "horizontal" && "@sm:w-control-narrow")}>
      {children}
    </section>
  );
};
